







import Vue from 'vue';
import { AppPublicScopes } from '../../constants/appScope';
import { LocaleInterface } from '../../types/settingsInterface';

export default Vue.extend({
  name: 'TheLangSwitcher',
  computed: {
    isPublic(): boolean {
      const scope = this.getScope();
      return !!scope && AppPublicScopes.indexOf(scope) !== -1;
    },
    languages(): LocaleInterface {
      return this.getScopeLanguages();
    },
  },
  watch: {
    '$i18n.locale'() {
      localStorage.locale = this.$i18n.locale;
      this.$store.dispatch('calendar/changeMaterialLocation');
    },
  },
});
